import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { message, notification } from 'antd';
import { GET_TOKEN, REMOVE_Division, REMOVE_EXP, REMOVE_REFRESHTOKEN, REMOVE_TOKEN } from './utils/token';
import { stringify } from 'querystring';
import { history } from '@umijs/max';

// 错误处理方案： 错误类型
enum ErrorShowType {
    SILENT = 0,
    WARN_MESSAGE = 1,
    ERROR_MESSAGE = 2,
    NOTIFICATION = 3,
    REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
    success: boolean;
    data: any;
    resultMsg?: string;
    syncDate?: string;
}


const loginOut = async () => {
    REMOVE_Division()
    REMOVE_REFRESHTOKEN()
    REMOVE_TOKEN()
    REMOVE_EXP()
    history.push('/login');
};
/**
 * @name 错误处理
 * pro 自带的错误处理， 可以在这里做自己的改动
 * @doc https://umijs.org/docs/max/request#配置
 */
export const errorConfig: RequestConfig = {
    // 错误处理： umi@3 的错误处理方案。
    errorConfig: {
        // 错误抛出
        errorThrower: (res) => {
            const { success, data, resultMsg, syncDate } = res as unknown as ResponseStructure;
            if (!success) {
                const error: any = new Error(resultMsg);
                error.name = 'BizError';
                error.info = { resultMsg, data };
                throw error; // 抛出自制的错误
            }
        },
        // 错误接收及处理
        errorHandler: (error: any, opts: any) => {
            if (opts?.skipErrorHandler) throw error;
            // 我们的 errorThrower 抛出的错误。
            if (error.name === 'BizError') {
                const errorInfo: ResponseStructure | undefined = error.info;
                if (errorInfo) {
                    const { resultMsg } = errorInfo;
                    message.error(resultMsg);
                }
            } else if (error.response) {
                if (error.response.status === 401) {
                    // message.error('请先登录！');
                    message.error('身份认证过期，请重新登录！');
                    setTimeout(() => {
                        loginOut();
                    }, 500);
                }
                // Axios 的错误
                // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
                else message.error(`Response status:${error.response.status}`);
                // GlobalMessage();
            } else if (error.request) {
                // 请求已经成功发起，但没有收到响应
                // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
                // 而在node.js中是 http.ClientRequest 的实例
                message.error('None response! Please retry.');
            } else {
                // 发送请求时出了点问题
                message.error('Request error, please retry.');
            }
        },
    },

    // 请求拦截器
    requestInterceptors: [
        (config: RequestOptions) => {
            // 拦截请求配置，进行个性化处理。
            const token = GET_TOKEN();
            //有token则在后续请求的请求头中携带token
            if (token) {
                // console.log(token);
                config!.headers!.Authorization = 'Bearer ' + token;
            }
            return config
        },
    ],

    // 响应拦截器
    responseInterceptors: [
        (response) => {
            // 拦截响应数据，进行个性化处理
            const { data } = response as unknown as ResponseStructure;

            if (data?.success === false) {
                message.error('请求失败！');
            }
            return response;
        },
    ],
};
